import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axiosClient from '../api/axiosClient';

function mergeUserOrganizerConfig(prev, incoming) {
    if (!incoming || typeof incoming !== 'object') return prev ?? null;
    const base = prev && typeof prev === 'object' ? prev : {};
    return {
        ...base,
        ...incoming,
        organizer_config: {
            ...(base.organizer_config || {}),
            ...(incoming.organizer_config || {}),
        },
    };
}

const stateContext = createContext({
    loading: true,
    user: null,
    token: null,
    setUser: () => {},
    setToken: () => {},
    fetchUserProfile: async () => {},
});

export const ContextProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, _setToken] = useState(localStorage.getItem('ACCESS_TOKEN'));
    const [loading, setLoading] = useState(true);

    const setToken = (value) => {
        _setToken(value);
        if (value) {
            localStorage.setItem('ACCESS_TOKEN', value);
        } else {
            localStorage.removeItem('ACCESS_TOKEN');
        }
    };

    const fetchUserProfile = useCallback(async () => {
        const currentToken = localStorage.getItem('ACCESS_TOKEN');
        if (!currentToken) {
            setUser(null);
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const { data } = await axiosClient.get('/user');

            if (data.status_email_confirmation === 0 || data.status_account === 0) {
                setToken(null);
                setUser(null);
                return;
            }

            setUser((prev) => mergeUserOrganizerConfig(prev, data));
        } catch {
            setToken(null);
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (token) {
            fetchUserProfile();
        } else {
            setUser(null);
            setLoading(false);
        }
    }, [token, fetchUserProfile]);

    return (
        <stateContext.Provider
            value={{
                loading,
                user,
                token,
                setUser,
                setToken,
                fetchUserProfile,
            }}
        >
            {children}
        </stateContext.Provider>
    );
};

export const useStateContext = () => useContext(stateContext);
